import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CallToAction() {
  return <section data-section-id="230195" id="contactcta" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto flex max-w-screen-xl flex-col items-center px-4 text-center sm:px-6 lg:px-8">
        <div className="w-full max-w-4xl rounded-lg border border-border/50 bg-card/50 p-12 backdrop-blur-md shadow-xl">
          <h2 className="font-default mb-4 text-4xl font-bold tracking-tight text-foreground md:text-5xl">
            Sicherheitsanalyse anfordern
          </h2>
          <p className="font-default mb-10 text-lg font-medium text-muted-foreground md:text-xl">
            Lassen Sie uns gemeinsam Ihre digitale Infrastruktur härten und Schwachstellen eliminieren.
          </p>
          <Link to="/ContactPage">
            <Button size="lg" className="rounded-sm px-8 py-6 text-base font-semibold bg-primary text-primary-foreground hover:shadow-[0_0_20px_rgba(0,180,216,0.4)] transition-all duration-300">
              Jetzt Kontakt aufnehmen
              <ArrowRight className="ml-2 size-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}